module.exports = __webpack_public_path__ + "static/media/Axon I -premiun.982620db.png";